import { type SelectOption } from '@synqo/frontend-component-library';

export const getYesNoLabel = (value: boolean) => (value ? 'Ja' : 'Nein');

export const yesNoOptions: SelectOption<string>[] = [
    {
        name: 'yes',
        label: getYesNoLabel(true),
        value: 'true',
    },
    {
        name: 'no',
        label: getYesNoLabel(false),
        value: 'false',
    },
];
